import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Package, Tag, FolderTree, Users } from "lucide-react";

export default function AdminDashboard() {
    const [stats, setStats] = useState({ products: 0, brands: 0, categories: 0, leads: 0 });
    const [recentLeads, setRecentLeads] = useState([]);

    useEffect(() => {
        (async () => {
            const [s, l] = await Promise.all([api.get("/admin/stats"), api.get("/admin/leads")]);
            setStats(s.data);
            setRecentLeads(l.data.slice(0, 5));
        })();
    }, []);

    const cards = [
        { label: "Produtos", value: stats.products, icon: Package, color: "text-brand-blue" },
        { label: "Marcas", value: stats.brands, icon: Tag, color: "text-brand-blue" },
        { label: "Categorias", value: stats.categories, icon: FolderTree, color: "text-brand-blue" },
        { label: "Leads", value: stats.leads, icon: Users, color: "text-brand-yellow-hover" },
    ];

    return (
        <div className="p-8">
            <div>
                <div className="text-xs font-mono uppercase tracking-[0.24em] text-neutral-500">Visão geral</div>
                <h1 className="mt-1 font-heading font-black text-3xl tracking-tight">Dashboard</h1>
            </div>

            <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {cards.map((c) => (
                    <div key={c.label} className="bg-white border border-neutral-300 p-6" data-testid={`stat-${c.label.toLowerCase()}`}>
                        <div className="flex items-center justify-between">
                            <span className="text-xs font-mono uppercase tracking-widest text-neutral-500">{c.label}</span>
                            <c.icon size={18} className={c.color} />
                        </div>
                        <div className="mt-4 font-heading font-black text-4xl tracking-tight">{c.value}</div>
                    </div>
                ))}
            </div>

            <div className="mt-10 bg-white border border-neutral-300">
                <div className="p-4 border-b border-neutral-200 flex items-center justify-between">
                    <div>
                        <div className="text-xs font-mono uppercase tracking-widest text-neutral-500">últimos</div>
                        <div className="font-heading font-bold text-lg">Leads recentes</div>
                    </div>
                </div>
                {recentLeads.length === 0 ? (
                    <div className="p-8 text-center font-mono text-sm text-neutral-500">nenhum lead ainda</div>
                ) : (
                    <table className="w-full">
                        <thead className="bg-neutral-50 font-mono text-xs uppercase tracking-widest text-neutral-500">
                            <tr>
                                <th className="text-left p-3">E-mail</th>
                                <th className="text-left p-3">Empresa</th>
                                <th className="text-left p-3">Origem</th>
                                <th className="text-left p-3">Quando</th>
                            </tr>
                        </thead>
                        <tbody>
                            {recentLeads.map((l) => (
                                <tr key={l.id} className="border-t border-neutral-200 font-mono text-sm">
                                    <td className="p-3">{l.email}</td>
                                    <td className="p-3 text-neutral-600">{l.company || "—"}</td>
                                    <td className="p-3 text-neutral-500">{l.source}</td>
                                    <td className="p-3 text-neutral-500">{new Date(l.created_at).toLocaleString("pt-BR")}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            <div className="mt-8 border border-dashed border-neutral-300 bg-white p-6">
                <div className="font-mono text-xs uppercase tracking-widest text-brand-blue">Roadmap · Fase atual</div>
                <div className="mt-1 font-heading font-bold text-lg">Fase 0 + Fase 1 — Alicerce & Núcleo de Dados (PIM)</div>
                <p className="mt-2 text-sm text-neutral-600">Próximo: Fase 2 — Importação em massa (CSV/XLSX).</p>
            </div>
        </div>
    );
}
